exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Contact/Contact.scss
 ** module id = 154
 ** module chunks = 0
 **/